import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { useConfigService, ExperienceContext } from '@thd-nucleus/experience-context';
import { initIndexDB } from '@thd-olt-global/thd-storage-utils';
import { AssistantProvider } from './AssistantProvider';
import { DrawerProvider } from './DrawerProvider';
import { MagicApronAssistant } from './MagicApronAssistant';
import { getPageType, getPath } from '../../utils/assistant-context-utils';

const indexDBConfig = {
  version: 1,
  stores: {
    sessions: {
      storeConfig: { keyPath: 'sessionId' },
      indexes: [{ name: 'sessionId', unique: true }],
    },
    messages: {
      storeConfig: { keyPath: 'id', autoIncrement: true },
      indexes: [{ name: 'id', unique: true }],
    }
  }
};

initIndexDB('assistantBotDB', indexDBConfig).catch(() => {});

export const AssistantWrapper = ({ withPersistence, withPortal, force }) => {

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const isEnabledMobile = useConfigService('fs-prop:magic-apron-assistant-mw-enabled');
  const isEnabledDT = useConfigService('fs-prop:magic-apron-assistant-dt-enabled');
  // this is to ensure we are only rendering assistant on the correct page types that are in scope
  const isAssistantCompatiblePage = !(getPageType() === 'Home' && getPath() !== '/');

  if ((!isAssistantCompatiblePage || (!(isEnabledMobile && isMobile)
    && !(isEnabledDT && !isMobile))) && !force) return null;

  return (
    <AssistantProvider withPersistence={withPersistence}>
      <DrawerProvider>
        <MagicApronAssistant withPortal={withPortal} />
      </DrawerProvider>
    </AssistantProvider>
  );
};

AssistantWrapper.propTypes = {
  withPersistence: PropTypes.bool,
  withPortal: PropTypes.bool,
  force: PropTypes.bool
};

AssistantWrapper.defaultProps = {
  withPersistence: true,
  withPortal: true,
  force: false
};

AssistantWrapper.dataModel = extend(MagicApronAssistant);
